var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgA = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 4",
  viewBox: "0 0 200 174.716"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "A_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200v174.716H0z",
  "data-name": "Rectangle 16",
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3",
  style: {
    clipPath: "url(#A_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M144.247 0c-19.034 0-35.334 13.565-44.283 22.905C91.051 13.565 74.787 0 55.753 0 22.905 0 0 22.869 0 55.611c0 36.115 28.48 59.446 56 82 13 10.653 26.456 21.661 36.755 33.913a9.2 9.2 0 0 0 6.96 3.2h.532a9.15 9.15 0 0 0 6.961-3.2c10.333-12.252 23.757-23.26 36.789-33.913 27.522-22.55 56-45.881 56-82C200 22.869 177.1 0 144.247 0",
  "data-name": "Path 2"
}))));
export default SvgA;